import React, {Component} from 'react'
import TableHeadItems from "./TableHeadItems"
import NextItemFilter from "./NextItemFilter"
import ListNextItemsTable from "./ListNextItemsTable"
import ListItemsPagination from "./ListItemsPagination"
import {searchListPackagedItemsV3} from "../../../services/api/apiNextBox"
import { getListPartner } from '../../../services/api/3dApi'
import ShowTotalItems from "./ShowTotalItems"

class NextItemsPage extends Component {
    state = {
        filter: {
            barcode: '',
            box_ids: [],
            location_type: 'all',
            shipment_status: 'all'
        },
        page: 1,
        limit: 50,
        total: 0,
        items: [],
        loading: false,
        error: '',
        listPartner: []
    }

    componentDidMount() {
        const { barcode } = this.props;
        
        if (barcode) {
            this.setState(prev => ({
                filter: {
                    ...prev.filter,
                    barcode: barcode
                }
            }), () => {
                this._fetchListBoxesItems(); // load data sau khi set barcode
            });
        } else {
            // Không có barcode → load như bình thường
            this._fetchListBoxesItems();
        }

        // this._fetchListBoxesItems()
        this._getPartner()
    }

    _fetchListBoxesItems = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {page, limit, filter} = this.state
            const filterClone = {...filter}
            
            if(filter.partners){
                filterClone.partners = [filter.partners]
            }else{
                delete filterClone.partners
            }
            
            const {success, data, message} = await searchListPackagedItemsV3({
                ...filterClone,
                page,
                limit
            })

            if (!success) {
                throw new Error(message)
            }

            const {items, total, page: vPage, limit: vLimit} = Object.assign({}, data)

            this.setState({
                loading: false,
                error: '',
                items: Array.isArray(items) ? items : [],
                total,
                page: vPage,
                limit: vLimit,
            })
        } catch (e) {
            return this.setState({
                loading: false,
                error: e.message || e,
            })
        }
    }

    _getPartner = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            hidden: false,
        }
        try {
            const { data, success } = await getListPartner(payload)
            const { partners: listPartner } = data
            if (!success) return

            this.setState({
                listPartner
            })
        } catch (e) {
        }
    }

    _handleChangePage = async (page) => {
        return new Promise((resolve, reject) => {
            this.setState({
                page,
            }, async () => {
                try {
                    await this._fetchListBoxesItems()
                    return resolve(true)
                } catch (e) {
                    return reject(e)
                }
            })
        })
    }

    _handleChangeFilter = async (field, value) => {
        return new Promise(resolve => {
            this.setState(({filter}) => ({
                filter: {
                    ...filter,
                    [field]: value,
                },
                page: 1,
                limit: 50,
            }), resolve)
        })
    }

    _handleChangeCreate = filter => {
        this.setState({
            filter,
            page: 1,
            limit: 50,
        })
    }

    _handleSubmitFilter = async () => {
        return this._fetchListBoxesItems()
    }

    render() {
        const {items, filter, loading, total, page, limit, listPartner} = this.state

        return (
            <div className="NextItemsPage">
                <div className="card">
                    <div className="card-header">
                        <NextItemFilter
                            total={total}
                            filter={filter}
                            onSubmit={this._handleSubmitFilter}
                            onChange={this._handleChangeFilter}
                            onChangeDate={this._handleChangeCreate}
                            listPartner={listPartner}
                        />
                        <div className="Right d-flex align-items-center justify-content-end">
                            <ShowTotalItems total={total}/>
                        </div>
                    </div>
                    <div className="card-body">
                        <table className="table">
                            <TableHeadItems/>
                            <ListNextItemsTable
                                items={items}
                                loading={loading}
                                fetchListBoxesItems={this._fetchListBoxesItems}
                            />
                        </table>
                    </div>
                    <div className="card-footer">
                        <ListItemsPagination
                            total={total}
                            page={page}
                            limit={limit}
                            loading={loading}
                            onChange={this._handleChangePage}/>
                    </div>
                </div>
            </div>
        )
    }
}


export default NextItemsPage
